import { Injectable, OnInit } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../../auth';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';

@Injectable()
export class EmployerViewService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }

    /**
     * Update employer
     * @param employer entity to be updated
     */
    updateEmployerStatus(supplierUuid) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/status/'+ supplierUuid;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams();

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Retrieves data about the employer specified by its uuid
     * @param uuid The uuid of the employer to be retrieved
     */
    getEmployerById(uuid) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/' + uuid;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * get employer by org id and country code
     * @param orgId org id of employer
     * @param countryCode country code of employer
     * @returns employer object
     */
    getEmployerByOrgId(orgId: String, countryCode: String) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/byOrgId/' + orgId + '/' + countryCode;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    getEmployerInformation() {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/information';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }   

    /**
     * Save new notes
     * @param employerId employer identifier
     * @param notes notes object
     */
    saveNotes(employerId, notes) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/' + employerId + '/notes';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('notesBody', JSON.stringify(notes));

        return this.http.post(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Delete notes
     * @param employerId employer identity
     * @param notes notes object
     */
    deleteNotes(employerId, noteId) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/' + employerId + '/notes/' + noteId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());


        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get projects by organisation
     * @param employerId 
     * @returns 
     */
    getAllSuaProjectByEmployerId(employerId): Observable<any> {     
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project/organisation/' + employerId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    // Depricated
    getAllSuaRegisterControls(employerId): Observable<any> {        
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-registercontrol/supplier/' + employerId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Delete an attachment belonging to supplier
     * @param attachmentId uuid of attachment
     * @param supplierId uuid of supplier 
     */
     deleteAttachment(attachmentId, supplierId) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/supplierattachment/' + attachmentId + '/' + supplierId;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }
    
    /**
     * Retrieves data about the current employers subemployers if they exist
     * @param uuid The uuid of the employer to be retrieved
     */
    getAllsubEmployersByParentId(uuid) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/employer/subEmployers/' + uuid;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }
}
